import { AriseFeesFields } from "globalConstants";

export const feesHeader1 = {
	row: [
		{
			value: "Per Item Fee",
		},
	],
};

export const feesHeader2 = {
	row: [
		{
			value: "Setup Fee",
		},
		{
			value: "Monthly Fee",
		},
	],
};

export const feesHeader3 = {
	row: [
		{
			value: "Setup Fee",
		},
		{
			value: "Monthly Fee",
		},
		{
			value: "Per Item Fee",
		},
	],
};

export const platformFees = [
	{
		setup: AriseFeesFields.PlatformSetupFee,
		monthly: AriseFeesFields.PlatformMonthlyFee,
	},
];

export const enhancesPlatformFees = [
	{
		setup: AriseFeesFields.CustomerVaultMonthlyFee,
		monthly: AriseFeesFields.CustomerVaultSetupFee,
		perItem: AriseFeesFields.CustomerVaultAutomaticUpdateFee,
	},
	{
		setup: AriseFeesFields.MobileInvoicingPaymentsSetupFee,
		monthly: AriseFeesFields.MobileInvoicingPaymentsMonthlyFee,
		perItem: AriseFeesFields.MobileInvoicingPaymentsMessageFee,
	},
];

export const cardProcessingFees = [
	{
		perItem: AriseFeesFields.CardTransactionAuthorizationFee,
	},
	{
		setup: AriseFeesFields.ECommercePluginSetupFee,
		monthly: AriseFeesFields.ECommercePluginMonthlyFee,
	},
	{
		setup: AriseFeesFields.EMVDeviceSetupFee,
		monthly: AriseFeesFields.AdditionalEmvDeviceMonthlyFee,
	},
	{
		setup: AriseFeesFields.EnhancedDataSetupFee,
		perItem: AriseFeesFields.EnhancedDataTransactionFee,
	},
];

export const cardNetworkTokenizationFees = [
	{
		setup: AriseFeesFields.CardNetworkTokenizationSetupFee,
		monthly: AriseFeesFields.CardNetworkTokenizationMonthlyFee,
		perItem: AriseFeesFields.CardNetworkPerTokenizationEventFee,
	},
];
